module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/icon_rotate_48x48.2dfac1f1.svg";